export const defaultState = {
  id: null,
  user: null,
  userOption: null,
  course: null,
  courseOption: null,
  name: '',
  completionDate: null,
  completionPlace: '',
  controlNumber: '',
  cpdHours: '',
  competencies: [],
  competencyOptions: [],
  isProgramme: false,
  programmeSubset: '',
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    const item = action.payload;
    const competencies = (item.competencies || []).map((c) => ({
      value: `${c.type}:${c.id}`,
      label: c.name,
      type: c.type,
      entityId: c.id,
    }));

    return {
      ...state,
      id: item.id,
      user: item.userId,
      userOption: item.userId ? { value: item.userId, label: item.userName } : null,
      course: item.courseId,
      courseOption: item.courseId ? { value: item.courseId, label: item.courseName } : null,
      name: item.name || '',
      completionDate: item.completionDate ? new Date(item.completionDate) : null,
      completionPlace: item.completionPlace || '',
      controlNumber: item.controlNumber || '',
      cpdHours: item.cpdHours ?? '',
      competencies,
      isProgramme: !!item.isProgramme,
      programmeSubset: item.programmeSubset || '',
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
